<template>
  <b-row class="justify-content-md-center m-0">
    <b-col lg="6" class="py-3">
      <div v-for="rule in rules" :key="rule.index" class="text-detail">
        <h5 class="font-weight-bold">{{ rule.title }}</h5>
        <ol class="text-detail__list">
          <li v-for="content in rule.contents" :key="content.index" class="text-detail__content">
            {{ content.title }}
            <ol class="text-detail__list">
              <li
                v-for="item in content.list_items"
                :key="item.index"
                v-safe-html="item.message"
                class="text-detail__list-item"
              ></li>
            </ol>
            <span
              v-if="content.message"
              v-safe-html="content.message"
              class="text-detail__list-message"
            >
            </span>
          </li>
        </ol>
        <div class="footer-text-detail">
          <p v-safe-html="rule.effective_date"></p>
          <p v-safe-html="rule.contact_us"></p>
          <hr />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  data() {
    return {
      rules: [
        {
          lang: 'th',
          title: 'ข้อกำหนดเกี่ยวกับการชำระเงิน',
          effective_date: 'วันที่มีผลบังคับใช้: 1 กรกฎาคม 2568',
          contact_us:
            'หากมีคำถามเกี่ยวกับข้อกำหนดและเงื่อนไขเหล่านี้ กรุณาติดต่อเราที่ <a href="mailto:4life@mail.kmutt.ac.th">4life@mail.kmutt.ac.th</a>',
          contents: [
            {
              title: 'วิธีการชำระเงิน และข้อมูลการเรียกเก็บเงิน',
              list_items: [
                {
                  message:
                    '“ผู้ใช้” ได้รับทราบว่าเรารองรับวิธีการชำระเงินรูปแบบต่าง ๆ โดยอ้างอิงจาก <a href="https://support.4lifelonglearning.org/hc/th/articles/22327038890393-วิธีการชำระเงิน">ลิงค์</a>'
                },
                {
                  message:
                    'เมื่อผู้ใช้ให้ข้อมูลการชำระเงินของผู้ใช้กับเรา ผู้ใช้ตกลงชำระเงินเต็มจำนวนจากการซื้อของผู้ใช้ รวมถึงภาษีและค่าธรรมเนียม (ถ้ามี) ที่เกี่ยวข้องทั้งหมด'
                },
                {
                  message:
                    'เพื่อหลีกเลี่ยงปัญหาการชำระเงินไม่สำเร็จจากข้อมูลที่ไม่ครบถ้วน ผู้ใช้ตกลงที่จะให้ข้อมูลการเรียกเก็บเงินที่ถูกต้องและสมบูรณ์ รวมถึงชื่อของผู้ใช้, ที่อยู่ในการเรียกเก็บเงิน, รายละเอียดการชำระเงิน, รวมถึงข้อมูลที่จำเป็นสำหรับการออกใบเสร็จ'
                },
                {
                  message:
                    'หากวิธีการชำระเงินของผู้ใช้ล้มเหลวหรือบัญชีของผู้ใช้มีค้างชำระ เราอาจระงับหรือยกเลิกการเข้าถึงแพลตฟอร์มของผู้ใช้จนกว่ายอดค้างชำระจะได้รับการชำระเต็มจำนวน'
                }
              ]
            },
            {
              title: 'ราคาและสกุลเงิน',
              list_items: [
                {
                  message:
                    'ราคาทั้งหมดที่แสดงบนแพลตฟอร์มจะเป็นสกุลเงินบาท เว้นแต่จะระบุไว้เป็นอย่างอื่น'
                },
                {
                  message:
                    'จำนวนเงินทั้งหมดที่จะเรียกเก็บจะแสดงอย่างชัดเจนในระหว่างขั้นตอนการชำระเงิน โดยการดำเนินการชำระเงิน ผู้ใช้ยอมรับที่จะชำระเงินในจำนวนที่แสดง'
                },
                {
                  message:
                    'ราคาสามารถเปลี่ยนแปลงได้ตลอดเวลา อย่างไรก็ตาม ราคาสุดท้ายที่ใช้ในการซื้อจะเป็นราคาที่แสดงในขณะทำธุรกรรมเท่านั้น'
                }
              ]
            },
            {
              title: 'การขอคืนเงิน',
              message:
                'หากผู้ใช้ประสงค์ส่งคำขอคืนเงิน กรุณาส่งคำขอไปยัง <a href="mailto:4lifeadmin@mail.kmutt.ac.th">4lifeadmin@mail.kmutt.ac.th</a> และเราจะดำเนินการตรวจสอบตามเงื่อนไข หากคำขอเป็นไปตามเงื่อนไข จะดำเนินการคืนเงินภายใน <span class="text-highlight">45 วันทำการ</span> โดยผู้ใช้สามารถศึกษาเงื่อนไขการคืนเงินและขั้นตอนการขอคืนเงินได้จาก <a href="https://support.4lifelonglearning.org/hc/th/sections/22666838542489-นโยบายการคืนเงิน">ลิงค์</a>'
            },
            {
              title: 'ขอบเขตความรับผิดชอบ',
              message:
                'ขอบเขตความรับผิดชอบ ของ 4lifelonglearning จะถูกจำกัดแค่จำนวนเงินที่ผู้ใช้ได้ชำระเพื่อซื้อสินค้าและ/หรือ บริการเท่านั้น (ไม่รวมถึงค่าธรรมเนียมและค่าบริการอื่นๆ ถ้ามี)'
            },
            {
              title: 'การเปลี่ยนแปลงนโยบาย',
              list_items: [
                {
                  message:
                    'เมื่อการชำระเงินเสร็จสิ้น ผู้ใช้จะได้รับใบเสร็จรับเงินในรูปแบบ PDF บนแพลตฟอร์ม โดยผู้ใช้สามารถศึกษาวิธีการรับใบเสร็จได้จาก <a href="https://support.4lifelonglearning.org/hc/th/articles/22327038890393-วิธีการชำระเงิน">ลิงค์</a>'
                }
              ]
            },
            {
              title: 'การปฏิเสธการชำระเงินและข้อพิพาท',
              list_items: [
                {
                  message:
                    'หากผู้ใช้เริ่มต้นการปฏิเสธการชำระเงินหรือข้อพิพาท โดยไม่ติดต่อทีมสนับสนุนของเราเพื่อแก้ไขปัญหา เราขอสงวนสิทธิ์ในการระงับหรือยกเลิกบัญชีของผู้ใช้'
                },
                {
                  message:
                    'การปฏิเสธการชำระเงินที่เป็นการฉ้อโกงจะถูกแจ้งให้หน่วยงานที่เกี่ยวข้องทราบ และผู้ใช้อาจต้องรับผิดชอบต่อค่าใช้จ่ายใดๆ ที่เกิดขึ้นโดยแพลตฟอร์มเนื่องจากการกระทำดังกล่าว'
                }
              ]
            }
          ]
        },
        {
          lang: 'en',
          title: 'Payment policy',
          effective_date: 'Effective Date: July, 1 2025',
          contact_us:
            'If you have any questions about these Terms and Conditions, please contact us at <a href="mailto:4life@mail.kmutt.ac.th">4life@mail.kmutt.ac.th</a>',
          contents: [
            {
              title: 'Payment Methods and Billing Information',
              list_items: [
                {
                  message:
                    'The "User" acknowledges that we support various payment methods, as referenced in the provided <a href="https://support.4lifelonglearning.org/hc/en-us/articles/22327038890393-Payment-Method">Link</a>.'
                },
                {
                  message:
                    'By providing their payment information, the User agree to pay the full amount of their purchase, including all applicable taxes and fees (if any).'
                },
                {
                  message:
                    'To avoid payment failures, the User agrees to provide accurate and complete billing information, including their name, billing address, payment details, and any other necessary information for issuing receipts.'
                },
                {
                  message:
                    'If the User’s payment method fails or their account has outstanding payments, we may suspend or terminate access to the platform until the outstanding balance is fully paid.'
                }
              ]
            },
            {
              title: 'Pricing and Currency',
              list_items: [
                {
                  message:
                    'All prices displayed on the platform are in Thai Baht unless otherwise specified.'
                },
                {
                  message:
                    'The total amount to be charged will be clearly shown during the payment process. By proceeding with the payment, the User agrees to pay the displayed amount.'
                },
                {
                  message:
                    'Prices are subject to change at any time. However, the final price applied to a purchase will be the price displayed at the time of the transaction.'
                }
              ]
            },
            {
              title: 'Refund Requests',
              message:
                'If the User wishes to request a refund, they must submit their request to <a href="mailto:4lifeadmin@mail.kmutt.ac.th">4lifeadmin@mail.kmutt.ac.th</a>. We will review the request according to our refund policy, and if it meets the conditions, the refund will be processed within <span class="text-highlight">45 business days</span>. Users can review the refund conditions and request procedures via the provided <a href="https://support.4lifelonglearning.org/hc/en-us/sections/22666838542489-Refund-Policy">Link</a>.'
            },
            {
              title: 'Limitation of Liability',
              message:
                'The liability of 4LifelongLearning is limited to the amount the User has paid for the purchased goods and/or services. This does not include any additional fees or service charges, if applicable.'
            },
            {
              title: 'Payment Receipt Issuance',
              list_items: [
                {
                  message:
                    'Upon successful payment, the User will receive a receipt in PDF format via the platform. Users can review how to obtain their receipt through the provided <a href="https://support.4lifelonglearning.org/hc/en-us/articles/22327038890393-Payment-Method">Link</a>.'
                }
              ]
            },
            {
              title: 'Payment Disputes and Chargebacks',
              list_items: [
                {
                  message:
                    'If a User initiates a chargeback or dispute without first contacting our support team to resolve the issue, we reserve the right to suspend or terminate their account.'
                },
                {
                  message:
                    'Fraudulent chargebacks will be reported to the relevant authorities, and the User may be held responsible for any costs incurred by the platform due to such actions.'
                }
              ]
            }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.text-detail {
  line-height: 26.44px;
  counter-reset: section;
  margin-bottom: 32px;
}

.text-detail__content {
  font-weight: 700;
  line-height: 26px;
  padding: 5px 0;
  counter-increment: section;
}
.text-detail__content::marker {
  content: counter(section) '. ';
}
.text-detail__content {
  padding: 5px 0;
}
.text-detail__list {
  padding-inline-start: 24px;
  counter-reset: subsection;
}
.text-detail__list-item {
  font-size: 15.2px;
  font-weight: 400;
  line-height: 22.32px;
  counter-increment: subsection;

  ::v-deep a {
    color: var(--primary);
    text-decoration: underline;
  }
}

.text-detail__list-item::marker {
  content: counter(section) '.' counter(subsection) ' ';
}

.text-detail__list-message {
  font-size: 15.2px;
  font-weight: 400;
  padding-inline-start: 24px;

  ::v-deep .text-highlight {
    color: var(--primary);
  }
  ::v-deep a {
    color: var(--primary);
    text-decoration: underline;
  }
}

.footer-text-detail {
  font-size: 15.2px;
  hr {
    border-top: 2px solid rgba(7, 9, 25, 0.1);
  }
  p {
    margin: 0;
  }
  ::v-deep a {
    color: var(--primary);
    text-decoration: underline;
  }
}
</style>
